module.exports = "<div class=\"three-bounce\" *ngIf=\"show\">\n    <div class=\"one\"></div>\n    <div class=\"two\"></div>\n    <div class=\"three\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-spinner/ui-spinner.html
// module id = 1073
// module chunks = 3